function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNonRefundable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.242 1.22l.531.53-9.015 9.03-.532-.53 9.016-9.03z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.137 2.483c.214-.182.558-.424 1.103-.7l.013-.007.013-.005a4.552 4.552 0 012.92-.191 4.542 4.542 0 013.223 5.582A4.594 4.594 0 014.801 10.4 4.542 4.542 0 011.58 4.817l.724.196a3.792 3.792 0 002.691 4.661 3.843 3.843 0 004.69-2.708 3.792 3.792 0 00-2.69-4.661 3.802 3.802 0 00-2.428.153c-.493.252-.783.46-.942.596a1.444 1.444 0 00-.174.172c-.001.002 0 .002 0 0l.003-.003.001-.003.001-.002.001-.001-.32-.195-.32-.196.002-.003.003-.004a.55.55 0 01.024-.036 2.178 2.178 0 01.292-.3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26 3.749h1.963L2.262 1.789l-.002 1.96z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.534 6.946a.414.414 0 00-.147-.327c-.097-.085-.264-.158-.495-.23l-.374-.11c-.374-.109-.646-.258-.82-.448-.175-.19-.265-.433-.265-.736 0-.255.065-.48.191-.675.126-.194.305-.343.532-.453.228-.109.492-.165.789-.165.296 0 .548.048.792.141.243.093.438.222.593.392l-.358.716a1.305 1.305 0 00-1.023-.47c-.195 0-.35.041-.46.118a.378.378 0 00-.166.32c0 .116.045.217.138.294.094.077.24.15.443.206l.37.11c.402.113.694.27.885.472.191.202.284.465.284.784 0 .263-.065.494-.19.692a1.243 1.243 0 01-.533.452 1.967 1.967 0 01-.828.158 2.36 2.36 0 01-.914-.174 1.772 1.772 0 01-.683-.485l.35-.72c.329.405.735.607 1.218.607.216 0 .382-.04.496-.121a.395.395 0 00.17-.344l.005-.004z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.594 3.947v-.836h.694v.836h-.694zM5.594 8.89v-.833h.694v.833h-.694z",
    fill: props.color
  }));
}

export default SvgIconNonRefundable;